/* D Byk — My Garage: bike profile + fit checks for tyres, tubes, cassettes, chains, tubeless valves, shifters, derailleurs, brakes */
(function () {
  'use strict';

  var KEY = 'dbyk-garage-v1';
  var FKEY = 'dbyk-garage-filter';

  // Groupset presets: speed, freehub body, system, largest cog the rear derailleur takes
  var DRIVES = {
    road12: { n: 'Shimano 105 12-speed (mechanical)', speed: 12, hub: 'hg11', sys: 'hg', max: 36 },
    road12di2: { n: 'Shimano Di2 12-speed', speed: 12, hub: 'hg11', sys: 'hg', max: 36 },
    road11: { n: 'Shimano 11-speed road', speed: 11, hub: 'hg11', sys: 'hg', max: 34 },
    grx11: { n: 'Shimano GRX 11-speed', speed: 11, hub: 'hg11', sys: 'hg', max: 34 },
    tiagra10: { n: 'Shimano Tiagra 10-speed', speed: 10, hub: 'hg', sys: 'hg', max: 34 },
    sora9: { n: 'Shimano Sora 9-speed', speed: 9, hub: 'hg', sys: 'hg', max: 34 },
    claris8: { n: 'Shimano Claris 8-speed', speed: 8, hub: 'hg', sys: 'hg', max: 34 },
    sramaxs: { n: 'SRAM AXS 12-speed road', speed: 12, hub: 'xdr', sys: 'flattop', max: 36 },
    mtb12: { n: 'Shimano 12-speed MTB', speed: 12, hub: 'ms', sys: 'hg', max: 51 },
    mtb11: { n: 'Shimano Deore 11-speed', speed: 11, hub: 'hg', sys: 'hg', max: 51 },
    mtb10: { n: 'Shimano Deore 10-speed', speed: 10, hub: 'hg', sys: 'hg', max: 46 },
    mtb9: { n: 'Shimano 9-speed MTB', speed: 9, hub: 'hg', sys: 'hg', max: 36 },
    mtb8: { n: 'Shimano 8-speed MTB', speed: 8, hub: 'hg', sys: 'hg', max: 34 },
    eagle: { n: 'SRAM Eagle 12-speed', speed: 12, hub: 'xd', sys: 'eagle', max: 52 },
    cues9: { n: 'Shimano CUES 9-speed', speed: 9, hub: 'hg', sys: 'linkglide', max: 46 },
    cues10: { n: 'Shimano CUES 10-speed', speed: 10, hub: 'hg', sys: 'linkglide', max: 48 },
    cues11: { n: 'Shimano CUES 11-speed', speed: 11, hub: 'hg', sys: 'linkglide', max: 50 },
    tourney7: { n: 'Shimano 7-speed cassette', speed: 7, hub: 'hg', sys: 'hg', max: 34 },
    tourney7fw: { n: 'Shimano 7-speed freewheel', speed: 7, hub: 'fw', sys: 'hg', max: 34 },
    ss: { n: 'Single speed', speed: 1, hub: 'ss', sys: 'ss', max: 0 }
  };
  // Which cassette freehub types each bike freehub accepts
  var HUBS = { hg11: ['hg', 'hg11'], hg: ['hg'], ms: ['ms'], xdr: ['xdr', 'xd'], xd: ['xd'], fw: ['fw'], ss: [] };
  var WHEEL = { 622: '700c / 29"', 584: '27.5"', 559: '26"', 507: '24"', 406: '20"' };
  var BRAKES = {
    rim_road: 'road rim brakes', rim_v: 'V-brakes',
    mech_shimano: 'Shimano mechanical disc', mech_zoom_hl: 'Zoom HL-280 disc', mech_zoom_db: 'Zoom DB-series disc',
    mech_lyra: 'Tektro Lyra disc', mech_novela: 'Tektro Novela disc', mech_iox: 'Tektro IOX disc', mech_c550: 'Tektro MD-C550 disc',
    mech_bb5: 'Avid BB5 disc', mech_bb7: 'Avid BB7 disc', mech_promax: 'Promax disc',
    hyd_shimano_road: 'Shimano road hydraulic', hyd_shimano_b: 'Shimano MT200-series hydraulic', hyd_shimano_g: 'Shimano Deore/SLX/XT 2-piston',
    hyd_shimano_4p: 'Shimano 4-piston', sram_road: 'SRAM road hydraulic', sram_mtb: 'SRAM Level/Elixir/DB', hyd_tektro: 'Tektro hydraulic'
  };

  // ---------- storage (never trusted to exist) ----------
  function load() {
    try { var b = JSON.parse(localStorage.getItem(KEY)); return b && b.bead ? b : null; } catch (e) { return null; }
  }
  function save(b) { try { localStorage.setItem(KEY, JSON.stringify(b)); } catch (e) {} }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }
  // Filter toggle is remembered per collection, for this visit only
  function fkey() { return FKEY + ':' + location.pathname; }
  function filterOn() { try { return sessionStorage.getItem(fkey()) === '1'; } catch (e) { return false; } }
  function setFilter(on) { try { sessionStorage.setItem(fkey(), on ? '1' : '0'); } catch (e) {} }

  var bike = load();

  function bikeName(b) { return (b && b.name) || 'your bike'; }
  function toMm(v) {
    var n = parseFloat(String(v || '').replace(',', '.'));
    if (!n || n <= 0) return null;
    return n <= 5 ? Math.round(n * 25.4) : Math.round(n); // inches → mm
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // ---------- fit rules: returns {s: 'yes'|'no'|'check', why} or null ----------
  function check(spec, b) {
    if (!spec || !b) return null;
    var d = b.drive ? DRIVES[b.drive] : null;

    if (spec.t === 'tyre') {
      if (spec.bead !== b.bead) return { s: 'no', why: 'Wrong wheel size for ' + WHEEL[b.bead] + ' wheels' };
      if (b.maxw) {
        if (spec.w > b.maxw) return { s: 'no', why: spec.w + 'mm is wider than your frame clearance (' + b.maxw + 'mm)' };
      } else if (spec.w > b.w + 3) {
        return { s: 'check', why: spec.w + 'mm is wider than your current ' + b.w + 'mm tyre — check frame clearance' };
      }
      if (spec.w < b.w * 0.6) return { s: 'check', why: 'Much narrower than your ' + b.w + 'mm tyre — check your rim width' };
      return { s: 'yes', why: spec.w + 'mm fits your ' + WHEEL[b.bead] + ' wheels' };
    }

    if (spec.t === 'tube') {
      if ((spec.bead || []).indexOf(b.bead) < 0) return { s: 'no', why: 'Wrong wheel size for ' + WHEEL[b.bead] + ' wheels' };
      if (spec.wmin && (b.w < spec.wmin || b.w > spec.wmax)) return { s: 'no', why: 'Made for ' + spec.wmin + '–' + spec.wmax + 'mm tyres; yours are ' + b.w + 'mm' };
      if (b.valve && spec.valve && spec.valve !== b.valve) {
        if (b.valve === 'presta') return { s: 'no', why: "A Schrader valve won't fit a Presta rim" };
        return { s: 'check', why: 'Presta valve in a Schrader rim needs an adapter' };
      }
      if (spec.valve === 'presta' && b.rim) {
        if (!spec.vlen) return { s: 'check', why: 'Valve length not listed — check it suits your rim' };
        if (spec.vlen < b.rim) return { s: 'no', why: spec.vlen + 'mm valve is too short for your rim (need ' + b.rim + 'mm+)' };
      }
      return { s: 'yes', why: 'Fits your ' + b.w + 'mm tyres' };
    }

    if (spec.t === 'fender' || spec.t === 'insert') {
      var thing = spec.t === 'fender' ? 'Mudguards' : 'Inserts';
      if ((spec.bead || []).indexOf(b.bead) < 0) return { s: 'no', why: thing + " don't fit " + WHEEL[b.bead] + ' wheels' };
      if (spec.wmin && (b.w < spec.wmin || b.w > spec.wmax)) return { s: 'no', why: 'Made for ' + spec.wmin + '–' + spec.wmax + 'mm tyres; yours are ' + b.w + 'mm' };
      return { s: 'yes', why: spec.wmin ? 'Made for ' + spec.wmin + '–' + spec.wmax + 'mm tyres — yours are ' + b.w + 'mm' : 'Fits ' + WHEEL[b.bead] + ' wheels' };
    }

    if (spec.t === 'tvalve' || spec.t === 'ext') {
      if (b.valve === 'schrader') return { s: 'no', why: 'Presta only — your rims take Schrader valves' };
      if (spec.t === 'ext') return { s: 'yes', why: 'Adds length to a Presta valve with a removable core' };
      if (b.rim && spec.vlen < b.rim) return { s: 'no', why: spec.vlen + 'mm valve is too short for your rim (need ' + b.rim + 'mm+)' };
      return { s: 'yes', why: b.rim ? spec.vlen + 'mm valve suits your rim depth' : 'Presta tubeless valve' };
    }

    if (spec.t === 'shift' || spec.t === 'rd') {
      var part = spec.t === 'rd' ? 'derailleur' : 'shifter';
      if (!d) return { s: 'check', why: 'Add your gears in My Garage to check' };
      if ((spec.drives || []).indexOf(b.drive) < 0) return { s: 'no', why: 'This ' + part + " isn't compatible with your " + d.n };
      if (spec.maxcog && d.max > spec.maxcog) return { s: 'check', why: 'Short cage — only for cassettes up to ' + spec.maxcog + 'T' };
      return { s: 'yes', why: 'Matches your ' + d.n };
    }

    if (spec.t === 'pad' || spec.t === 'brake') {
      if (!b.brake) return { s: 'check', why: 'Add your brakes in My Garage to check' };
      if ((spec.fam || []).indexOf(b.brake) < 0) return { s: 'no', why: (spec.t === 'pad' ? 'These pads don\'t fit ' : 'Not for ') + 'your ' + BRAKES[b.brake] };
      if (spec.note) return { s: 'check', why: spec.note };
      return { s: 'yes', why: 'Made for your ' + BRAKES[b.brake] };
    }

    if (spec.t === 'rotor' || spec.t === 'rotoracc') {
      if (b.brake && b.brake.indexOf('rim_') === 0) return { s: 'no', why: 'Your bike has rim brakes' };
      var mt = spec.mount === 'cl' ? 'Center Lock' : '6-bolt';
      if (!b.rotor) return { s: 'check', why: mt + ' — add your rotor mount in My Garage to check' };
      if (spec.mount !== b.rotor) return { s: 'no', why: mt + ' — your hubs take ' + (b.rotor === 'cl' ? 'Center Lock' : '6-bolt') + ' rotors' };
      if (spec.t === 'rotoracc') return { s: 'yes', why: 'Fits Center Lock hubs' };
      return { s: 'yes', why: mt + ' fits your hubs' + (spec.size ? ' — check ' + spec.size + 'mm matches your current rotor' : '') };
    }

    if (spec.t === 'cassette') {
      if (!d) return { s: 'check', why: 'Add your gears in My Garage to check' };
      if (d.speed === 1) return { s: 'no', why: 'Your bike is single speed' };
      if (spec.speed !== d.speed) return { s: 'no', why: spec.speed + '-speed — your bike is ' + d.speed + '-speed' };
      if ((HUBS[d.hub] || []).indexOf(spec.hub) < 0) return { s: 'no', why: "Doesn't fit your wheel's freehub" };
      if ((spec.sys === 'linkglide') !== (d.sys === 'linkglide')) return { s: 'no', why: spec.sys === 'linkglide' ? 'Linkglide cassette — for Shimano CUES only' : 'Your CUES drivetrain needs a Linkglide cassette' };
      if (spec.cog && spec.cog > d.max) return { s: 'no', why: 'Biggest cog (' + spec.cog + 'T) is too big for your derailleur (max ' + d.max + 'T)' };
      return { s: 'yes', why: 'Matches your ' + d.n };
    }

    if (spec.t === 'chain' || spec.t === 'link') {
      if (!d) return { s: 'check', why: 'Add your gears in My Garage to check' };
      var what = spec.t === 'link' ? 'link' : 'chain';
      if ((spec.speeds || []).indexOf(d.speed) < 0) return { s: 'no', why: 'Wrong speed for your ' + d.speed + (d.speed === 1 ? ' speed' : '-speed') + ' drivetrain' };
      if ((spec.sys === 'flattop') !== (d.sys === 'flattop')) return { s: 'no', why: spec.sys === 'flattop' ? 'SRAM Flattop ' + what + ' — for SRAM AXS road only' : 'SRAM AXS road needs a Flattop ' + what };
      if ((spec.sys === 'linkglide') !== (d.sys === 'linkglide')) return { s: 'no', why: spec.sys === 'linkglide' ? 'Linkglide ' + what + ' — for Shimano CUES only' : 'Your CUES drivetrain needs a Linkglide ' + what };
      return { s: 'yes', why: 'Matches your ' + d.n };
    }
    return null;
  }

  // Best result across a product's variants (for cards)
  function summarise(vars, b) {
    var yes = [], chk = null, no = null;
    vars.forEach(function (v) {
      var r = check(v.s, b);
      if (!r) return;
      if (r.s === 'yes') yes.push(v);
      else if (r.s === 'check') chk = chk || r;
      else no = no || r;
    });
    if (yes.length) {
      var label = 'Fits ' + bikeName(b);
      if (vars.length > 1 && yes.length < vars.length && yes.length <= 2) label += ' · ' + yes.map(function (v) { return v.t.split(' / ')[0]; }).join(', ');
      return { s: 'yes', label: label };
    }
    if (chk) return { s: 'check', label: 'Check fit' };
    if (no) return { s: 'no', label: "Doesn't fit " + bikeName(b) };
    return null;
  }

  function readData(el) {
    try { return JSON.parse(el.textContent).filter(function (v) { return v.s; }); } catch (e) { return []; }
  }

  var ICON = {
    yes: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>',
    no: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    check: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 7v6M12 17h.01"/></svg>',
    bike: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="5.5" cy="16.5" r="3.5"/><circle cx="18.5" cy="16.5" r="3.5"/><path d="M5.5 16.5L9 9h6l3.5 7.5M9 9l3 7.5 3-7.5M8 6h3"/></svg>'
  };

  // ---------- product cards ----------
  function renderCards() {
    var nodes = document.querySelectorAll('script.mg-data:not([data-pdp])');
    nodes.forEach(function (el) {
      var next = el.nextElementSibling;
      if (next && next.classList.contains('mg-badge')) next.remove();
      var item = el.closest('li, .grid__item') || el.closest('.card-wrapper');
      if (item) item.removeAttribute('data-mg');
      if (!bike) return;
      var sum = summarise(readData(el), bike);
      if (!sum) return;
      var p = document.createElement('p');
      p.className = 'mg-badge mg-badge--' + sum.s;
      p.innerHTML = ICON[sum.s] + '<span>' + esc(sum.label) + '</span>';
      el.after(p);
      if (item) item.setAttribute('data-mg', sum.s);
    });
    applyFilter();
  }

  // ---------- collection bar + filter ----------
  function gridRoot() {
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.querySelector('script.mg-data')) return null;
    return document.getElementById('ProductGridContainer') || grid;
  }

  function renderBar() {
    var root = gridRoot();
    var wrap = document.querySelector('.mg-bar-wrap');
    if (!root) { if (wrap) wrap.remove(); return; }
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'mg-bar-wrap page-width';
      root.parentNode.insertBefore(wrap, root);
    }
    if (bike) {
      wrap.innerHTML = '<div class="mg-bar">' +
        '<div class="mg-bar__bike">' + ICON.bike + '<span>Showing fit for <b>' + esc(bikeName(bike)) + '</b></span>' +
        '<button type="button" class="mg-bar__edit" data-mg-open>Change</button></div>' +
        '<div class="mg-bar__right"><label class="mg-toggle"><input type="checkbox" data-mg-filter' + (filterOn() ? ' checked' : '') + '>' +
        '<span class="mg-toggle__ui" aria-hidden="true"></span><span>Only show parts that fit</span></label>' +
        '<span class="mg-bar__count" aria-live="polite"></span></div></div>';
    } else {
      wrap.innerHTML = '<div class="mg-bar">' +
        '<div class="mg-bar__bike">' + ICON.bike + '<span><b>Will it fit?</b> Add your bike and we\'ll mark what fits.</span></div>' +
        '<button type="button" class="mg-btn mg-btn--sm" data-mg-open>Add my bike</button></div>';
    }
    applyFilter();
  }

  // When the filter is on, pull in the collection's other pages so matches on page 2+ show up too
  var loadingAll = false;
  function gridSectionId() {
    var grid = document.getElementById('product-grid');
    var sec = grid && grid.closest('.shopify-section');
    return sec && sec.id ? sec.id.replace('shopify-section-', '') : null;
  }
  function lastPage() {
    var max = 1;
    document.querySelectorAll('.pagination a[href*="page="], .pagination-wrapper a[href*="page="]').forEach(function (a) {
      try { var n = parseInt(new URL(a.href, location.href).searchParams.get('page'), 10); if (n > max) max = n; } catch (e) {}
    });
    return Math.min(max, 10);
  }
  function currentPage() {
    try { return parseInt(new URLSearchParams(location.search).get('page'), 10) || 1; } catch (e) { return 1; }
  }
  function loadAllPages() {
    var grid = document.getElementById('product-grid');
    if (!grid || grid.getAttribute('data-mg-all') || loadingAll) return;
    grid.setAttribute('data-mg-all', '1');
    var last = lastPage(), cur = currentPage(), sid = gridSectionId();
    if (last <= 1 || !sid) return;
    var pages = [];
    for (var p = 1; p <= last; p++) if (p !== cur) pages.push(p);
    loadingAll = true;
    var count = document.querySelector('.mg-bar__count');
    if (count) count.textContent = 'Checking all pages…';
    Promise.all(pages.map(function (p) {
      var u = new URL(location.href);
      u.searchParams.set('page', p);
      u.searchParams.set('section_id', sid);
      return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      loadingAll = false;
      if (document.getElementById('product-grid') !== grid) return; // grid was replaced (filters/sort changed)
      htmls.forEach(function (h) {
        if (!h) return;
        var doc = new DOMParser().parseFromString(h, 'text/html');
        doc.querySelectorAll('#product-grid > li, #product-grid > .grid__item').forEach(function (li) {
          var node = document.importNode(li, true);
          node.classList.add('mg-extra');
          grid.appendChild(node);
        });
      });
      renderCards();
    });
  }

  function applyFilter() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var hasFit = !!grid.querySelector('script.mg-data'); // only collections with fit data get filtered
    var on = !!bike && hasFit && filterOn();
    if (on) loadAllPages();
    var items = grid.querySelectorAll(':scope > li, :scope > .grid__item');
    var shown = 0, total = 0;
    items.forEach(function (li) {
      var extra = li.classList.contains('mg-extra');
      if (on || !extra) total++;
      var hide = on ? li.getAttribute('data-mg') !== 'yes' : extra;
      li.classList.toggle('mg-hidden', hide);
      if (!hide && on) shown++;
    });
    grid.classList.toggle('mg-filtering', on);
    document.querySelectorAll('.pagination-wrapper').forEach(function (p) { p.classList.toggle('mg-hidden', on); });
    var count = document.querySelector('.mg-bar__count');
    if (count && !loadingAll) count.textContent = on ? shown + ' of ' + total + ' fit' : '';
    var empty = document.querySelector('.mg-empty');
    if (on && !loadingAll && shown === 0 && total > 0) {
      if (!empty) {
        empty = document.createElement('p');
        empty.className = 'mg-empty';
        empty.innerHTML = 'Nothing here fits ' + esc(bikeName(bike)) + ' yet. <a href="https://wa.me/917020425618" target="_blank" rel="noopener">Ask us on WhatsApp</a> and we\'ll find the right part.';
        grid.parentNode.insertBefore(empty, grid);
      }
    } else if (empty) empty.remove();
  }

  // ---------- product page ----------
  var pdpVariant = null;
  function currentVariantId(vars) {
    var input = document.querySelector('product-info input[name="id"], form[action*="/cart/add"] input[name="id"]');
    var id = input && input.value;
    if (!id) { try { id = new URLSearchParams(location.search).get('variant'); } catch (e) {} }
    var v = vars.filter(function (x) { return String(x.id) === String(id); })[0];
    return v || vars.filter(function (x) { return x.a; })[0] || vars[0];
  }

  function renderPdp(force) {
    var el = document.querySelector('script.mg-data[data-pdp]');
    if (!el) return;
    var all;
    try { all = JSON.parse(el.textContent); } catch (e) { return; }
    var v = currentVariantId(all);
    if (!v) return;
    if (!force && pdpVariant === v.id) return;
    pdpVariant = v.id;

    var box = document.querySelector('.mg-pdp');
    if (!box) {
      box = document.createElement('div');
      var anchor = document.querySelector('product-info product-form') ||
        document.querySelector('product-info .product-form') ||
        document.querySelector('.product__info-container .product-form');
      if (!anchor) return;
      anchor.parentNode.insertBefore(box, anchor);
    }

    if (!bike) {
      box.className = 'mg-pdp mg-pdp--empty';
      box.innerHTML = '<div class="mg-pdp__icon">' + ICON.bike + '</div><div class="mg-pdp__text"><b>Will this fit your bike?</b><span>Add your bike once and we\'ll check every part we can.</span></div>' +
        '<button type="button" class="mg-btn mg-btn--sm" data-mg-open>Add my bike</button>';
      return;
    }
    if (!v.s) {
      box.className = 'mg-pdp mg-pdp--check';
      box.innerHTML = '<div class="mg-pdp__icon">' + ICON.check + '</div><div class="mg-pdp__text"><b>We haven\'t checked this option yet</b><span>Message us and we\'ll confirm it fits ' + esc(bikeName(bike)) + '.</span></div>' +
        '<button type="button" class="mg-link" data-mg-open>Edit bike</button>';
      return;
    }
    var r = check(v.s, bike);
    if (!r) { box.className = 'mg-pdp mg-hidden'; box.innerHTML = ''; return; }
    var title = r.s === 'yes' ? 'Fits ' + bikeName(bike) : r.s === 'no' ? "Doesn't fit " + bikeName(bike) : 'Check fit for ' + bikeName(bike);
    var extra = '';
    if (r.s !== 'yes' && all.length > 1) {
      var alt = all.filter(function (x) { var c = check(x.s, bike); return c && c.s === 'yes'; }).map(function (x) { return x.t; });
      if (alt.length) extra = '<span class="mg-pdp__alt">Fits your bike: ' + esc(alt.slice(0, 3).join(', ')) + '</span>';
    }
    box.className = 'mg-pdp mg-pdp--' + r.s;
    box.innerHTML = '<div class="mg-pdp__icon">' + ICON[r.s] + '</div><div class="mg-pdp__text"><b>' + esc(title) + '</b><span>' + esc(r.why) + '</span>' + extra + '</div>' +
      '<button type="button" class="mg-link" data-mg-open>Edit bike</button>';
  }

  // ---------- dialog ----------
  var dlg, form;
  function openDialog() {
    dlg = dlg || document.getElementById('mg-dialog');
    form = form || document.getElementById('mg-form');
    if (!dlg || !form) return;
    var b = bike || {};
    form.name.value = b.name || '';
    form.bead.value = b.bead ? String(b.bead) : '';
    form.w.value = b.w || '';
    form.maxw.value = b.maxw || '';
    form.valve.value = b.valve != null ? b.valve : 'presta';
    form.rim.value = b.rim != null ? String(b.rim) : '40';
    form.drive.value = b.drive || '';
    if (form.brake) form.brake.value = b.brake || '';
    if (form.rotor) form.rotor.value = b.rotor || '';
    form.querySelector('[data-mg-clear]').hidden = !bike;
    form.querySelector('.mg-error').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function closeDialog() { if (dlg) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); } }

  function onSubmit(e) {
    e.preventDefault();
    var err = form.querySelector('.mg-error');
    var bead = parseInt(form.bead.value, 10);
    var w = toMm(form.w.value);
    var maxw = toMm(form.maxw.value);
    if (!bead || !w) {
      err.textContent = !bead ? 'Please choose your wheel size.' : 'Please enter your tyre width, e.g. 28 or 2.25.';
      err.hidden = false;
      return;
    }
    if (w < 16 || w > 130) { err.textContent = 'That tyre width looks off — try the number on your tyre, e.g. 28 or 2.25.'; err.hidden = false; return; }
    bike = {
      name: form.name.value.trim(),
      bead: bead, w: w, maxw: maxw && maxw >= w ? maxw : null,
      valve: form.valve.value || null,
      rim: form.rim.value ? parseInt(form.rim.value, 10) : null,
      drive: form.drive.value || null,
      brake: form.brake ? form.brake.value || null : null,
      rotor: form.rotor ? form.rotor.value || null : null
    };
    save(bike);
    closeDialog();
    refresh(true);
  }

  function refresh(force) { renderBar(); renderCards(); renderPdp(force); }

  // ---------- wiring ----------
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mg-open]')) { e.preventDefault(); openDialog(); return; }
    if (t.closest('[data-mg-close]')) { closeDialog(); return; }
    if (t.closest('[data-mg-clear]')) { bike = null; clear(); setFilter(false); closeDialog(); refresh(true); return; }
    if (dlg && t === dlg) closeDialog(); // backdrop click
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-mg-filter]')) { setFilter(e.target.checked); applyFilter(); }
  });

  function init() {
    form = document.getElementById('mg-form');
    dlg = document.getElementById('mg-dialog');
    if (form) form.addEventListener('submit', onSubmit);
    refresh(true);

    // Re-run when the theme swaps in new products (filters, sorting, quick-add)
    var pending = null;
    new MutationObserver(function (muts) {
      var relevant = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && !n.classList.contains('mg-badge') && !n.classList.contains('mg-bar-wrap') && !n.classList.contains('mg-pdp') && !n.classList.contains('mg-empty') &&
            (n.matches('script.mg-data') || (n.querySelector && n.querySelector('script.mg-data')));
        });
      });
      if (!relevant) return;
      clearTimeout(pending);
      pending = setTimeout(function () { renderBar(); renderCards(); }, 60);
    }).observe(document.body, { childList: true, subtree: true });

    // Product page: follow variant changes
    if (document.querySelector('script.mg-data[data-pdp]')) {
      document.addEventListener('change', function () { setTimeout(function () { renderPdp(false); }, 50); });
      setInterval(function () { renderPdp(false); }, 700);
    }
  }

  // Other tabs: keep the bike in sync
  window.addEventListener('storage', function (e) { if (e.key === KEY) { bike = load(); refresh(true); } });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
